import React from 'react';
import TableOfContentsWeatherProtectionItem from '../../../../organisms/tableofcontentweatherprotection/TableOfContentsWeatherProtectionItem';
import TableOfContentsItem from '../../../../organisms/tableofcontents/TableOfContentsItem';
import type { TableOfContentsDto as TableOfContents, ProjectDto } from '../../../../../api/generated/model';

interface TableOfContentsSectionProps {
    projectInfo: ProjectDto | undefined;
    tableOfContentData: TableOfContents | undefined;
    workerView: boolean;
}

const TableOfContentsSection: React.FC<TableOfContentsSectionProps> = ({
    projectInfo,
    tableOfContentData,
    workerView,
}) => {
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                <div className="templateTitle">Innehållsförteckning</div>
                {/* User role radio buttons are handled in the parent component */}
            </div>
            {projectInfo && projectInfo.department === 3 ? ( // 3 = WeatherProtection
                <TableOfContentsWeatherProtectionItem tableOfContents={tableOfContentData} disabled={workerView} projectNumber={projectInfo.projectNumber ?? ""} />
            ) : (
                <TableOfContentsItem tableOfContents={tableOfContentData} disabled={workerView} projectNumber={projectInfo?.projectNumber ?? ""} />
            )}
        </div>
    );
};

export default TableOfContentsSection; 